export default __webpack_public_path__ + "static/media/chicken-green.da65f6b2.svg";